<template>

    <body style="direction: rtl; text-align: right; background-color: #f0f4f8;padding-top: 60px;">
        <!-- Header -->
        <Header :pageTitle="'طلب المستقل'" />
        <!-- Main Container -->
        <div class="container my-4">
            <!-- Profile Card -->
            <div class="profile-card bg-light rounded p-4 shadow-sm">
                <span class="badge bg-warning text-dark px-3 py-2 mb-4">
                </span>
                <div class="d-flex justify-content-between align-items-center">
                    <p style="font-weight: bold;color: black;" class="m-0">{{ orderData.title ?? "لا يوجد عنوان" }}</p>
                </div>
                <div class=" align-items-center">
                    <p style="color: black;" class="mb-1 mt-2">ملاحظات:</p>
                    <br>
                    <p style="color: black;">{{ orderData.orders_note }}</p>
                </div>
                <p class="mt-3">{{ orderData.orders_details }}</p>

                <hr />
                <div class="d-flex justify-content-between mb-3">
                    <p class="mb-0"><strong>مدة الطلب:</strong> {{ orderData.orders_duration }}</p>
                </div>
                <div class="d-flex justify-content-between mb-3">
                    <p class="mb-0"><strong>السعر المقترح:</strong> {{ orderData.quotation_price ?? 0 }} $</p>
                </div>
                <div class="d-flex justify-content-between mb-3">
                    <p class="mb-0"><strong>عدد الايام المقترحة:</strong> {{ orderData.orders_duration }}</p>
                </div>
                <div class="d-flex justify-content-between">
                    <p class="mb-0"><strong>تفاصيل العرض:</strong> <span class="fw-bold">{{
                        orderData.quotation_description ?? "لا يوجد" }}</span></p>
                </div>
                <div class="mt-4 d-flex justify-content-between">
                    <button v-if="orderData.orders_type == 0" style="background-color: #2c9b00;color: #3f3f3f;"
                        class="btn flex-grow-1" @click="acceptOrder">قبول الطلب</button>
                    <button v-if="orderData.orders_type == 0" style="background-color: #ff2600;color: #3f3f3f;"
                        class="btn flex-grow-1 me-2" @click="rejectOrder">رفض الطلب</button>
                    <button v-if="orderData.orders_type == 1" style="background-color: #296080;color: #fff;"
                        class="btn flex-grow-1 me-2" @click="completeOrder">تم التنفيذ</button>
                </div>
            </div>
        </div>
        <!-- Footer -->
        <Footer />
    </body>
</template>

<script>
import Header from '../../components/header.vue';
import Footer from '../../components/footer.vue';
import axios from 'axios'; // استيراد axios

export default {
    name: 'OrderDetails',
    components: {
        Header,
        Footer,
    },
    props: ['id'], // استقبال ID الطلب من المسار
    data() {
        return {
            orderData: {},
        };
    },
    created() {
        const storedOrder = localStorage.getItem("selectedOrder");
        if (storedOrder) {
            this.orderData = JSON.parse(storedOrder);
            console.log("تم استرجاع بيانات الطلب:", this.orderData);
        } else {
            console.error("لا يوجد طلب مخزن.");
        }
    },
    methods: {
        getStatusText(type) {
            const statuses = {
                0: 'جديد',
                1: 'جاري التنفيذ',
                2: 'تم الانتهاء',
                3: 'تم الانتهاء والتقييم',
            };
            return statuses[type] || 'غير معروف';
        },

        // دالة قبول الطلب
        acceptOrder() {
            this.updateOrderStatus(1); // إرسال نوع الطلب 1 للقبول
        },

        // دالة رفض الطلب
        rejectOrder() {
            this.updateOrderStatus(2); // إرسال نوع الطلب 2 للرفض
        },

        // دالة لإرسال الطلب عبر الرابط
        updateOrderStatus(type) {
            const orderId = this.orderData.orders_id; // الحصول على ID الطلب
            console.log('جاري إرسال الطلب:', orderId);
            console.log('جاري :',  type);
            axios.post('https://zadcodeonline.com/ahmad/etqan/backEnd/orders/accept_orders.php',
                {
                    ordersid: orderId,
                    type: type,
                },
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                })
                .then(response => {
                    console.log('تم إرسال الطلب بنجاح:', response.data);
                    this.$router.push('/profile');
                    // يمكنك إضافة عملية تحديث حالة الطلب بعد النجاح
                })
                .catch(error => {
                    console.error('حدث خطأ عند إرسال الطلب:', error);
                });
        },
        completeOrder() {
            const orderId = this.orderData.orders_id; // الحصول على ID الطلب
            console.log('جاري إرسال الطلب:', orderId);
            axios.post('https://zadcodeonline.com/ahmad/etqan/backEnd/orders/status_order.php',
                {
                    ordersid: orderId,
                    status: 3,
                },
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                })
                .then(response => {
                    console.log('تم إرسال الطلب بنجاح:', response.data);
                    this.$router.push('/profile');
                    // يمكنك إضافة عملية تحديث حالة الطلب بعد النجاح
                })
                .catch(error => {
                    console.error('حدث خطأ عند إرسال الطلب:', error);
                });
        }
    },
};
</script>

<style scoped>
.profile-card {
    max-width: 600px;
    margin: auto;
}
</style>
